var F={50:"#FFF1F0",100:"#FFF1F0",200:"#FFE3E2",300:"#FFBAB6",400:"#FE8982",500:"#FE746C",600:"#D8635C",700:"#B2514C",800:"#7F3A36"};export{F as default};
